import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import logo from '../../images/logo.svg';
import { instituteRegistration } from '../../apis/AuthenticationAPI';
import Cookies from "universal-cookie";
import { toast } from "react-toastify";

const cookies = new Cookies();
const InstituteRegisteration = () => {
   const token = cookies.get("token")
   const history = useHistory();
   const handleBlur = (e) => {
      const newInstituteData = { ...instituteData };
      newInstituteData[e.target.name] = e.target.value;
      setInstituteData(newInstituteData);
   };
   useEffect(() => {
		if(token === null || token === undefined )
		{
			history.push("/page-login");
      }		
	}, [])
   const [instituteName, setInstituteName] = useState("");
   const [email, setEmail] = useState("");
   const [password, setPassword] = useState("");
   const [username, setUsername] = useState("");
   const [cpassword, setCPassword] = useState("");
   const [address, setAddress] = useState("");
   const [city, setCity] = useState("");
   const [state, setState] = useState("");
   const [country, setCountry] = useState("");
   const [description, setDescription] = useState("");
   const [contact, setContact] = useState("");
   const [credits, setCredits] = useState("");
   const [avatar,setAvatar] = useState("");
   const [instituteData, setInstituteData] = useState({});
   const submitHandler = (e) => {
      e.preventDefault();
      if(password === cpassword)
      {
         // console.log(avatar);
      instituteRegistration(token,instituteName,username,email,password,address,city,state,country,description,contact,credits,avatar)
      .then(response => {
         console.log(response);
         toast("Institute registered successfully!", {
            position: "top-right",
            autoClose: 10000,
          });
      })
      .catch(error => {
         console.log(error)
         toast("Error in registering institute.", {
            position: "top-right",
            autoClose: 10000,
          });
      })
      }
      
   };
   return (
      <div className="row justify-content-center  align-items-center h-100">
         <div className="col-md-6">
            <div className="authincation-content">
               <div className="row no-gutters">
                  <div className="col-xl-12">
                     <div className="auth-form">
						<div className="text-center mb-3">
							<Link to={"/"}><img src={logo} alt="" width = "300" /></Link>
						</div>
						<h4 className="text-center mb-4 text-white">Create Institute Account</h4>
                        <form action="" onSubmit={(e) => e.preventDefault(submitHandler)}>
                        <div className="form-group">
								<label className="mb-1 text-white"> <strong>Institute Name</strong> </label>
								<input type="text" className="form-control" placeholder="Instute Name" name="institutename" onChange={(e)=> setInstituteName(e.target.value)} />
                           </div>
                           <div className="form-group">
								<label className="mb-1 text-white"> <strong>Username</strong> </label>
								<input type="text" className="form-control" placeholder="username" name="name" onChange={(e)=> setUsername(e.target.value)} />
                           </div>
                           <div className="form-group">
                              <label className="mb-1 text-white ">   <strong>Email</strong>  </label>
                              <input  type="email" className="form-control"  placeholder="hello@example.com"  name="Email"  onChange={(e)=> setEmail(e.target.value)}   />
                           </div>
                           <div className="form-group">
                              <label className="mb-1 text-white">   <strong>Password</strong>  </label>
                              <input type="password" className="form-control" placeholder="Password" name="password" onChange={(e)=> setPassword(e.target.value)}  />
                           </div>
                           <div className="form-group">
                              <label className="mb-1 text-white">   <strong>Confirm Password</strong>  </label>
                              <input type="password" className="form-control" placeholder="Confirm Password" name = "cpassword" onChange={(e)=> setCPassword(e.target.value)}  />
                           </div>
                           <div className="form-group">
								<label className="mb-1 text-white"> <strong>Description</strong> </label>
								<input type="text" className="form-control" placeholder="Description" name="Description" onChange={(e)=> setDescription(e.target.value)} />
                           </div>
                           <div className="form-group">
								<label className="mb-1 text-white"> <strong>Credits</strong> </label>
								<input type="number" className="form-control" placeholder="Credits" name="credits" onChange={(e)=> setCredits(e.target.value)} />
                           </div>
                           <div className="form-group">
								<label className="mb-1 text-white"> <strong>Address</strong> </label>
								<input type="text" className="form-control" placeholder="Address" name="address" onChange={(e)=> setAddress(e.target.value)} />
                           </div>
                           <div className="form-group">
								<label className="mb-1 text-white"> <strong>City</strong> </label>
								<input type="text" className="form-control" placeholder="City" name="city" onChange={(e)=> setCity(e.target.value)} />
                           </div>
                           <div className="form-group">
								<label className="mb-1 text-white"> <strong>State</strong> </label>
								<input type="text" className="form-control" placeholder="State" name="state" onChange={(e)=> setState(e.target.value)} />
                           </div>
                           <div className="form-group">
								<label className="mb-1 text-white"> <strong>Country</strong> </label>
								<input type="text" className="form-control" placeholder="Country" name="country" onChange={(e)=> setCountry(e.target.value)} />
                           </div>
                           <div className="form-group">
								<label className="mb-1 text-white"> <strong>Contact</strong> </label>
								<input type="number" className="form-control" placeholder="Contact" name="contact" onChange={(e)=> setContact(e.target.value)} />
                           </div>
                           <div className="form-group">
                        <label className="mb-1 text-white"> <strong>Upload File</strong> </label>
								<input type="file" className="form-control" onChange={(e)=> setAvatar(e.target.files[0])} />
                           </div>
                           <div className="text-center mt-4">
                              <button type="submit" className="btn bg-white text-primary btn-block"  onClick={(e) => submitHandler(e)} >  Sign me up  </button>
                           </div>
                           
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default InstituteRegisteration;
